import { Omnisearch } from '../components/atomic/omnisearch.vue';
Vue.component('omnisearch', Omnisearch);